import React from 'react';
import { Container } from 'reactstrap';
import CrudList from './list';

const Processos = (props) => (
  <div className="containerInside__wrap">
    <Container>
      <CrudList search={props} />
    </Container>
  </div>
);

export default Processos;